import React from "react";
import Chart from "react-apexcharts";
import { Form } from "react-bootstrap";

const QueryStatusByVisit = () => {
  const data = [
    {
      visit: "Screening",
      open: 15,
      answered: 8,
      closed: 60,
      reopened: 2,
    },
    {
      visit: "Baseline / Day 1",
      open: 15,
      answered: 9,
      closed: 70,
      reopened: 4,
    },
    {
      visit: "Week 2",
      open: 14,
      answered: 12,
      closed: 70,
      reopened: 3,
    },
    {
      visit: "Week 4",
      open: 8,
      answered: 11,
      closed: 63,
      reopened: 2,
    },
    {
      visit: "Week 8",
      open: 17,
      answered: 15,
      closed: 63,
      reopened: 5,
    },
    {
      visit: "Week 12",
      open: 7,
      answered: 9,
      closed: 60,
      reopened: 3,
    },
    {
      visit: "Week 16",
      open: 9,
      answered: 2,
      closed: 66,
      reopened: 2,
    },
    {
      visit: "Week 24",
      open: 11,
      answered: 6,
      closed: 50,
      reopened: 5,
    },
    {
      visit: "Unscheduled",
      open: 17,
      answered: 5,
      closed: 66,
      reopened: 1,
    },
    {
      visit: "End of Study",
      open: 9,
      answered: 12,
      closed: 63,
      reopened: 4,
    },
  ];
  const options = {
    chart: {
      type: "bar",
      stacked: true,
      toolbar: {
        show: false,
      },
    },

    plotOptions: {
      bar: {
        horizontal: true,
        borderRadius: 3,
        barHeight: "72%",
      },
    },

    colors: [
      "#2563eb", // Open
      "#7c3aed", // Answered
      "#16a34a", // Closed
      "#ea580c", // Re-opened
    ],

    dataLabels: {
      enabled: false,
    },

    legend: {
      position: "top",
      horizontalAlign: "center",
      fontSize: "13px",
      markers: {
        width: 10,
        height: 10,
      },
    },

    stroke: {
      width: 0,
    },

    xaxis: {
      min: 0,
      max: 100,
      tickAmount: 10,
      categories: data.map((item) => item.visit),
    },

    grid: {
      borderColor: "#e2e8f0",
    },

    tooltip: {
      shared: true,
      intersect: false,
    },
  };

  const series = [
    {
      name: "Open",
      data: data.map((item) => item.open),
    },
    {
      name: "Answered",
      data: data.map((item) => item.answered),
    },
    {
      name: "Closed",
      data: data.map((item) => item.closed),
    },
    {
      name: "Re-opened",
      data: data.map((item) => item.reopened),
    },
  ];

  return (
    <>
      <div className="p-3">
        <Chart options={options} series={series} type="bar" height={280} />
      </div>
    </>
  );
};

export default QueryStatusByVisit;
